/*=========================================================================================
  File Name: store.js
  Description: Vuex store
==========================================================================================*/

import Vue from 'vue'
import Vuex from 'vuex'

import * as user from './modules/user.js'
import * as client from './modules/client.js'
import * as bill from './modules/bill.js'
import * as subject from './modules/subject.js'
import * as document from '@/store/modules/document.js'
import * as notification from '@/store/modules/notification.js'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    user,
    client,
    bill,
    document,
    notification,
    subject
  },
  strict: process.env.NODE_ENV !== 'production'
})
